<template>
  <div class="d-flex align-center justify-end flex-nowrap ma-2">
    <b class="text-no-wrap">Page {{ page }}</b>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn small v-on="on" text>
          {{ Math.min(pageSize * page, numbers) }}/{{ numbers }}
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item-group mandatory v-model="pageSize">
          <v-list-item
            v-for="(item, index) in pageSizes"
            :key="index"
            :value="item"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <custom-pagination
      v-model="page"
      :disable-next="numbers < pageSize"
    ></custom-pagination>
  </div>
</template>
<script>
import CustomPagination from '@/components/selects/customPageSelector/CustomPagination';
import { PAGE_SIZES } from '@/store/baseModule/constants';

export default {
  name: 'PropertyHeader',
  components: { CustomPagination },
  props: {
    namespace: {
      type: String,
      required: false,
      default: 'documents',
    },
  },
  data() {
    return {
      pageSizes: PAGE_SIZES,
    };
  },
  computed: {
    numbers: {
      get() {
        return this.$store.getters[`${this.namespace}/count`];
      },
    },
    page: {
      get() {
        return this.$store.getters[`${this.namespace}/pageIndex`] + 1;
      },
      set(val) {
        this.$store.dispatch(`${this.namespace}/setItemsPage`, val - 1);
      },
    },
    pageSize: {
      get() {
        return this.$store.getters[`${this.namespace}/pageSize`];
      },
      set(val) {
        this.$store.dispatch(`${this.namespace}/setItemsPageSize`, val);
      },
    },
  },
};
</script>
